import styled, { css } from 'styled-components'
import { BaseFreeCancellationContainer, BaseFreeCancellationText, FavoriteButton } from '../card-shared-styles'
import { wideScreenBreakpoint } from 'react-components'
import ExternalLink from '../external-link'

export const CardContainer = styled.div<{ $hasBottomTags?: boolean }>(
    ({ theme, $hasBottomTags }) => css`
        display: grid;
        grid-template-columns: 1fr auto;
        gap: ${theme.spacing.xxSmall};
        align-items: stretch;
        background: ${$hasBottomTags ? 'linear-gradient(190.38deg, #FFFFFF 72.45%, #EEE3FF 100%)' : theme.colors.white};
        border-radius: 1rem;
        padding: ${theme.spacing.medium};
        box-shadow:
            0px 1px 5px 0px #00000014,
            0px 2px 1px 0px #0000000a,
            0px 1px 2px 0px #0000000f;
        cursor: pointer;
        transition: box-shadow 0.2s ease;

        &:hover {
            box-shadow:
                0px 2px 8px 0px #00000020,
                0px 3px 2px 0px #0000000f,
                0px 2px 3px 0px #00000014;
        }
    `,
)

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`

export const LocationText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.large};
        color: #6c6c6c;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
)

export const TitleLink = styled(ExternalLink)`
    text-decoration: none;
    color: inherit;
    &:hover {
        text-decoration: underline;
    }
`

export const PropertyTitle = styled.h3(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.medium};
        line-height: 1.375rem;
        font-weight: 700;
        color: #282828;
        margin: 0;
        display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
        overflow: hidden;
    `,
)

export const PropertyDetails = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: 1.375rem;
        color: #282828;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
)

export const RatingRow = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        margin-top: ${theme.spacing.xxxSmall};
    `,
)

export const RatingContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xxSmall};
    `,
)

export const RatingValue = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.large};
        font-weight: 600;
        color: #282828;
    `,
)

export const RatingCount = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.large};
        font-weight: 400;
        color: #6c6c6c;
    `,
)

export const ImageSection = styled.div`
    position: relative;
    width: 7.125rem;
    height: 7.125rem;
    border-radius: ${({ theme }) => theme.typography.border.radius.xLarge};
    overflow: hidden;

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        width: 8.25rem;
        height: 8.25rem;
    }
`

export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`

export const CompactFavoriteButton = styled(FavoriteButton)`
    top: -0.5rem;
    right: -0.5rem;
`

export const BottomSection = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        grid-column: 1 / -1;
        margin-top: ${theme.spacing.xSmall};
    `,
)

export const PriceRow = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing.small};
        flex-wrap: nowrap;
        margin-top: ${theme.spacing.xxSmall};
    `,
)

export const SlasherPrice = styled.div(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        display: inline-flex;
        font-weight: 500;
        color: #aaaaaa;
        margin-right: 4px;
        text-decoration: line-through;
        white-space: nowrap;
        flex-shrink: 0;
    `,
)

export const PriceText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.medium};
        line-height: 1.5rem;
        font-weight: 700;
        color: #282828;
        white-space: nowrap;
        flex-shrink: 0;
    `,
)

export const FreeCancellationContainer = styled(BaseFreeCancellationContainer)`
    flex-shrink: 1;
    min-width: 0;
`

export const FreeCancellationText = styled(BaseFreeCancellationText)(
    ({ theme }) => css`
        font-size: 0.8125rem;
        line-height: ${theme.typography.font.size.large};
        color: #6c6c6c;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
    `,
)

export const BottomTraumTagRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.375rem;
    margin-top: 0.25rem;
`

export const GuestInfoText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.large};
        font-weight: 400;
        color: #6c6c6c;
    `,
)
